@use './scss/reset' as *;
@use './scss/colors' as *;
@use './scss/fonts' as *;
@use './scss/buttons' as *;

.App {
	text-align: center;
	display: flex;
	flex-direction: column;
	height: 1920rem;
	width: 100vw;
	background-color: $c-background-1a1a1a;
	* {
		color: $c-white-ffffff;
	}

	.screen-container {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}

	.top {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 409rem;

		&:has(.radio-buttons) {
			padding-top: 284rem;
		}

		&.less-padding {
			padding-top: 195rem;
		}

		> div {
			width: 70vw;

			> h1 {
				margin-bottom: 24rem;
				white-space: pre-line;
			}

			> p.p1 {
				margin-bottom: 128rem;
			}

			> .animation {
				width: 300rem;
				height: 300rem;
				position: fixed;
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
			}
		}
	}

	.buttons {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 72rem;
	}

	p.error-message {
		color: $c-feedback-red-bb0a30;
	}

	.offline-lamp {
		width: 7px;
		height: 7px;
		border-radius: 7px;
		background-color: #ff0000;
		border: solid 1px #303030;
		position: fixed;
		right: 8px;
		bottom: 20px;
		z-index: 100;
	}
}
